import { createStore } from '../_core/createStore';
import { errorReportingStore } from './errorReportingStore';
import { sentryErrorReporter } from './reporters/sentryErrorReporter';

const useErrorReportingStore = createStore({
  creator: errorReportingStore({ reporter: sentryErrorReporter }),
  id: 'errorReporting',
  middlewares: {
    devtools: true,
  },
});

export default useErrorReportingStore;
